import { load } from '@shopify/theme-sections';
import CartUtil from '../utils/cartUtil';
import FieldQuantity from '../components/field-quantity';
import Toast from '../components/Toast/Toast';
import { formatPrice } from '../utils/utilities';
import Swiper from 'swiper';
load('*');
const productForms = document.querySelectorAll('[data-product-form]');
const productImages = document.querySelectorAll('.product__image');
const productImageContainer = document.getElementById('product-image');
const floatingAddToCartButton = document.querySelector('.product-add__floating:not(.product-oos__floating)');
const floatingOutofStockContainer = document.querySelector('.product-oos__floating');
Toast.init();
// Initialize field quantity +/- component
const fieldQuantity = FieldQuantity()[0];
const hiddenQuantity = document.querySelector('[data-product-quantity]');
// Load product image with magnify
/*
productImages.forEach((productImage) => {
  const src = productImage.getAttribute('data-src');
  const alt = productImage.getAttribute('data-alt');

  ReactDOM.render(
    React.createElement(ProductImage, {
      src,
      alt,
    }),
    productImage
  );
});*/
let productCarouselContainer = document.querySelector('.product__media');
let productScrollContainer = document.querySelector('.product__media-scrollbar');
const indexChanged = (index) => {
    let productScrollActive = document.querySelector('.product__media-scrollbar__active');
    if (!productScrollActive)
        return;
    let activeImages = document.querySelectorAll('.product__image-active,.product__video-active');
    let thresholdHit = (activeImages.length * 63) > productCarouselContainer.offsetWidth;
    let totalWidth = productScrollContainer.offsetWidth;
    productScrollActive.style.transform = `translateX(${index * (thresholdHit ? totalWidth / activeImages.length : 63)}px)`;
};
let swiperContainer = document.querySelector('.product__media-inner');
const swiperNext = `.swiper-button-next`;
const swiperPrev = `.swiper-button-prev`;
const swiperNextButton = document.querySelector(swiperNext);
const swiperPrevButton = document.querySelector(swiperPrev);
let swiper = new Swiper(swiperContainer, {
    grabCursor: true,
    slidesPerView: 1,
    centeredSlides: false,
    navigation: false,
    on: {
        init: (swiper) => {
            indexChanged(swiper.activeIndex);
        },
        slideChange: (swiper) => {
            indexChanged(swiper.activeIndex);
            if (swiper.isEnd) {
                swiperNextButton.style.display = 'none';
            }
            else {
                swiperNextButton.style.display = 'flex';
            }
            if (swiper.isBeginning) {
                swiperPrevButton.style.display = 'none';
            }
            else {
                swiperPrevButton.style.display = 'flex';
            }
        }
    }
});
let productScrollItems = document.querySelectorAll('.product__media-scrollbar__item');
productScrollItems.forEach((productScrollItem, index) => {
    productScrollItem.addEventListener('click', () => {
        swiper.slideTo(index);
    });
});
if (swiperPrevButton) {
    swiperPrevButton.style.display = 'none';
    swiperNextButton.addEventListener('click', () => {
        swiper.slideNext();
        if (swiper.isEnd) {
            swiperNextButton.style.display = 'none';
        }
        else {
            swiperNextButton.style.display = 'flex';
        }
        if (swiper.isBeginning) {
            swiperPrevButton.style.display = 'none';
        }
        else {
            swiperPrevButton.style.display = 'flex';
        }
    });
    swiperPrevButton.addEventListener('click', () => {
        swiper.slidePrev();
        if (swiper.isBeginning) {
            swiperPrevButton.style.display = 'none';
        }
        else {
            swiperPrevButton.style.display = 'flex';
        }
        if (swiper.isEnd) {
            swiperNextButton.style.display = 'none';
        }
        else {
            swiperNextButton.style.display = 'flex';
        }
    });
}
const updateProductSlider = (targetSlide) => {
    swiper.update();
    if (swiperPrevButton) {
        if (swiper.isBeginning) {
            swiperPrevButton.style.display = 'none';
        }
        else {
            swiperPrevButton.style.display = 'flex';
        }
        if (swiper.isEnd) {
            swiperNextButton.style.display = 'none';
        }
        else {
            swiperNextButton.style.display = 'flex';
        }
    }
    productScrollContainer.innerHTML = '';
    let activeImages = document.querySelectorAll('.product__image-active,.product__video-active');
    let thresholdHit = (activeImages.length * 63) > productCarouselContainer.offsetWidth;
    if (thresholdHit) {
        productScrollContainer.style.width = '100%';
    }
    let totalWidth = productScrollContainer.offsetWidth;
    if (activeImages.length > 1) {
        activeImages.forEach((activeImage, index) => {
            let scrollElement = document.createElement('div');
            scrollElement.classList.add('product__media-scrollbar__item');
            productScrollContainer.appendChild(scrollElement);
            if (thresholdHit) {
                scrollElement.style.flex = '0 0 ' + (totalWidth / activeImages.length) + 'px';
            }
            scrollElement.addEventListener('click', () => {
                swiper.slideTo(index);
            });
        });
    }
    let productScrollActive = document.createElement('div');
    productScrollActive.classList.add('product__media-scrollbar__active');
    productScrollContainer.appendChild(productScrollActive);
    if (thresholdHit) {
        productScrollActive.style.flex = '0 0 ' + (totalWidth / activeImages.length) + 'px';
        productScrollActive.style.width = (totalWidth / activeImages.length) + 'px';
    }
    swiper.slideTo(targetSlide || 0);
    indexChanged(targetSlide || 0);
};
updateProductSlider(0);
const getVariant = (variantData, currentOptions, optionsToFind = -1) => {
    const variant = variantData.find((variant) => {
        let optionsFound = 0;
        variant.options.map((option) => {
            if (currentOptions.indexOf(option) > -1) {
                optionsFound++;
            }
        });
        return optionsFound == (optionsToFind == -1 ? variant.options.length : optionsToFind);
    });
    return variant;
};
let giftCardEmail = document.querySelector('#egift-card-recipient-email');
if (productForms && productForms.length) {
    productForms.forEach((productForm) => {
        let addingToCart = false;
        const addToCartButton = productForm.querySelector('[data-product-add-to-cart]');
        const backInStockButton = document.getElementById('BIS_trigger');
        const outOfStockContainer = document.querySelector('.product-oos');
        // Span Element that displays the Total Price in the AddToCartButton
        const totalText = addToCartButton ? addToCartButton.querySelector('[data-product-add-to-cart-total]') : null;
        // Hidden Input Element that stores any custom Item Reference
        // This is used only for electronic gift cards
        const itemRefInput = productForm.querySelector('[data-product-item-ref-input]');
        const optionDropdowns = productForm.querySelectorAll('.product-form__input--dropdown select');
        const optionRadios = productForm.querySelectorAll('.product-form__input--swatches input');
        const productIngredients = document.querySelectorAll('.product__ingredients');
        const complimentaryProductCheckbox = document.querySelector('.product__complimentary:not(.product__complimentary-variant) input');
        const complimentaryProductVariantCheckboxes = document.querySelectorAll('.product__complimentary-variant');
        const upsells = document.querySelector('.product-upsells');
        if (optionDropdowns.length > 0 || optionRadios.length > 0) {
            // Get json data from the product form child json element
            // Add event listener to each dropdown
            const variantData = JSON.parse(productForm.querySelector('[type="application/json"]').innerHTML);
            optionDropdowns.forEach((dropdown) => {
                dropdown.addEventListener('change', (event) => {
                    let currentOptions = [];
                    optionDropdowns.forEach((dropdown) => {
                        currentOptions.push(dropdown.value);
                    });
                    let currentRadio = productForm.querySelector(".product-form__input--swatches input:checked");
                    optionRadios.forEach((radio) => {
                        let optionVariant = currentOptions.join(' / ') + " / " + radio.value;
                        let variant = getVariant(variantData, optionVariant);
                        if (variant && !variant.available) {
                            radio.classList.add('disabled');
                        }
                        else {
                            radio.classList.remove('disabled');
                        }
                    });
                    if (currentRadio) {
                        currentOptions.push(currentRadio.value);
                    }
                    // Get the current variant
                    let variant = getVariant(variantData, currentOptions.join(' / '));
                    // Trigger the change event on the variant select
                    const variantSelect = productForm.querySelector('[name="id"]');
                    const variantSelectOptions = variantSelect.querySelectorAll('option');
                    variantSelectOptions.forEach((option) => {
                        if (option.value == variant.id) {
                            option.setAttribute('selected', 'selected');
                        }
                        else {
                            option.removeAttribute('selected');
                        }
                    });
                    if (variant.available && addToCartButton.classList.contains('product-add__hide')) {
                        addToCartButton.classList.remove('product-add__hide');
                        outOfStockContainer.classList.add('product-oos__hidden');
                    }
                    else if (!variant.available && !addToCartButton.classList.contains('product-add__hide')) {
                        addToCartButton.classList.add('product-add__hide');
                        outOfStockContainer.classList.remove('product-oos__hidden');
                    }
                    backInStockButton.dataset.variantId = variant.id;
                    const addToCartButtonSticky = document.querySelector('.sticky-bar__button .button');
                    if (!!addToCartButtonSticky)
                        addToCartButtonSticky.dataset.productVariantId = variant.id;
                    updateCartButtonPrice(getQuantity(), variant.price);
                    productIngredients.forEach(productIngredient => productIngredient.classList.remove('product__ingredients--active'));
                    let colorIngredients = document.querySelectorAll(`.product__ingredients[data-color="${currentRadio.value.toLowerCase()}"]`);
                    colorIngredients.forEach(colorIngredient => colorIngredient.classList.add('product__ingredients--active'));
                    variantSelect.dispatchEvent(new Event('change'));
                    if (upsells)
                        upsells.dispatchEvent(new CustomEvent('product-variant-change', { detail: { variant } }));
                    if (dataJs.singleVariant)
                        return;
                    let allImages = document.querySelectorAll('.product__image, .product__video');
                    let currentOptionValues = dataJs.options[currentRadio.getAttribute('name').toLowerCase()];
                    let imageIndex = 0;
                    let targetSlide = -1;
                    allImages.forEach((image) => {
                        let imageSrc = image.dataset.src.toLowerCase();
                        let imageAlt = image.dataset.alt.toLowerCase();
                        let hasOption = false;
                        currentOptionValues.map((option) => {
                            if (imageAlt.includes(option.toLowerCase())) {
                                hasOption = true;
                            }
                        });
                        let hasCurrentOption = imageAlt.includes(currentRadio.value.toLowerCase());
                        if (hasCurrentOption && targetSlide == -1) {
                            targetSlide = imageIndex;
                        }
                        if (!hasOption || hasCurrentOption) {
                            imageIndex++;
                            image.classList.add('product__image-active');
                            image.classList.add('product__video-active');
                        }
                        else {
                            image.classList.remove('product__image-active');
                            image.classList.remove('product__video-active');
                        }
                    });
                    if (targetSlide == -1)
                        targetSlide = 0;
                    updateProductSlider(targetSlide);
                });
            });
            // Add event listener to each radio
            optionRadios.forEach((radio) => {
                radio.addEventListener('change', () => {
                    let currentOptions = [];
                    let currentRadio = radio;
                    let selectedOptionsByName = {};
                    let parentContainer = currentRadio.closest('.product-form__input--swatches');
                    let variantTitle = parentContainer.querySelector('.form__label');
                    variantTitle.classList.remove('form__label--error');
                    variantTitle.innerHTML = `${variantTitle.dataset.name}: ${currentRadio.value}`;
                    optionDropdowns.forEach((dropdown) => {
                        Array.prototype.forEach.call(dropdown.options, (option) => {
                            let optionVariant = currentRadio.value + " / " + option.value;
                            let variant = getVariant(variantData, optionVariant);
                            if (variant && variant.available) {
                                option.classList.add('disabled');
                            }
                            else {
                                option.classList.remove('disabled');
                            }
                        });
                        currentOptions.push(dropdown.value);
                        selectedOptionsByName[dropdown.name] = dropdown.value;
                    });
                    let swatches = productForm.querySelectorAll('.product-form__input--swatches-wrapper');
                    swatches.forEach((swatch) => {
                        let currentSwatch = swatch.querySelector('input:checked');
                        if (!currentSwatch)
                            currentSwatch = swatch.querySelector('input');
                        if (currentSwatch.checked)
                            currentOptions.push(currentSwatch.value);
                        selectedOptionsByName[currentSwatch.name] = currentSwatch.value;
                    });
                    optionRadios.forEach((radio) => {
                        let currentOptionsExceptCurrent = Object.keys(selectedOptionsByName).filter((option) => selectedOptionsByName[option] != selectedOptionsByName[radio.name]);
                        let optionVariant = currentOptionsExceptCurrent.map(key => selectedOptionsByName[key]).join(' / ') + " / " + radio.value;
                        let variant = getVariant(variantData, optionVariant);
                        if (!variant || (variant && !variant.available)) {
                            radio.classList.add('disabled');
                        }
                        else {
                            radio.classList.remove('disabled');
                        }
                    });
                    // Get the current variant
                    let variant = getVariant(variantData, currentOptions.join(' / ')) || {};
                    // Trigger the change event on the variant select
                    const variantSelect = productForm.querySelector('[name="id"]');
                    const variantSelectOptions = variantSelect.querySelectorAll('option');
                    let firstPossibleVariant = !variant.id ? getVariant(variantData, currentOptions.join(' / '), currentOptions.length) : variant;
                    if (firstPossibleVariant.available && addToCartButton.classList.contains('product-add__hide')) {
                        addToCartButton.classList.remove('product-add__hide');
                        outOfStockContainer.classList.add('product-oos__hidden');
                    }
                    else if (!firstPossibleVariant.available && !addToCartButton.classList.contains('product-add__hide')) {
                        addToCartButton.classList.add('product-add__hide');
                        outOfStockContainer.classList.remove('product-oos__hidden');
                    }
                    backInStockButton.dataset.variantId = variant.id;
                    const addToCartButtonSticky = document.querySelector('.sticky-bar__button .button');
                    if (!!addToCartButtonSticky)
                        addToCartButtonSticky.dataset.productVariantId = variant.id;
                    updateCartButtonPrice(getQuantity(), firstPossibleVariant.price);
                    let variantTitles = document.querySelectorAll('.form__label');
                    variantTitles.forEach((title) => {
                        if (firstPossibleVariant.available && title.innerHTML.includes('(out of stock)')) {
                            title.innerHTML = title.innerHTML.replace('(out of stock)', '');
                        }
                        else if (!firstPossibleVariant.available && !title.innerHTML.includes('(out of stock)')) {
                            title.innerHTML = title.innerHTML + ' (out of stock)';
                        }
                    });
                    if (!variant.id) {
                        variantSelectOptions.forEach((option) => {
                            option.removeAttribute('selected');
                        });
                        variantSelectOptions[0].setAttribute('selected', 'selected');
                        return;
                    }
                    variantSelectOptions.forEach((option) => {
                        if (option.value == variant.id) {
                            option.setAttribute('selected', 'selected');
                        }
                        else {
                            option.removeAttribute('selected');
                        }
                    });
                    productIngredients.forEach(productIngredient => productIngredient.classList.remove('product__ingredients--active'));
                    let colorIngredients = document.querySelectorAll(`.product__ingredients[data-color="${currentRadio.value.toLowerCase()}"]`);
                    colorIngredients.forEach(colorIngredient => colorIngredient.classList.add('product__ingredients--active'));
                    variantSelect.dispatchEvent(new Event('change'));
                    if (upsells)
                        upsells.dispatchEvent(new CustomEvent('product-variant-change', { detail: { variant } }));
                    if (dataJs.singleVariant)
                        return;
                    let allImages = document.querySelectorAll('.product__image, .product__video');
                    let currentOptionValues = dataJs.options[currentRadio.getAttribute('name').toLowerCase()];
                    let imageIndex = 0;
                    let targetSlide = -1;
                    allImages.forEach((image) => {
                        if (image.dataset.variant)
                            return;
                        let imageSrc = image.dataset.src.toLowerCase();
                        let imageAlt = image.dataset.alt.toLowerCase();
                        let hasOption = false;
                        currentOptionValues.map((option) => {
                            if (imageAlt.includes(option.toLowerCase())) {
                                hasOption = true;
                            }
                        });
                        let hasCurrentOption = imageAlt.includes(currentRadio.value.toLowerCase());
                        if (hasCurrentOption && targetSlide == -1) {
                            targetSlide = imageIndex;
                        }
                        if (!hasOption || hasCurrentOption) {
                            imageIndex++;
                            image.classList.add('product__image-active');
                            image.classList.add('product__video-active');
                        }
                        else {
                            image.classList.remove('product__image-active');
                            image.classList.remove('product__video-active');
                        }
                    });
                    if (imageIndex == 0) {
                        let variantImage = document.querySelector(`.product__image[data-variant="${variant.id}"]`);
                        if (variantImage) {
                            variantImage.classList.add('product__image-active');
                            targetSlide = 0;
                        }
                        else {
                            let otherImages = document.querySelectorAll('.product__image');
                            otherImages.forEach((image) => {
                                image.classList.add('product__image-active');
                            });
                        }
                    }
                    if (targetSlide == -1)
                        targetSlide = 0;
                    updateProductSlider(targetSlide);
                });
            });
        }
        window.addEventListener('load', () => {
            addToCartButton.classList.add('product-add--ready');
            floatingAddToCartButton.classList.add('product-add--ready');
        });
        // Update the price in the Add to Cart button
        const updateCartButtonPrice = (qty, price = false) => {
            if (!price) {
                price = parseFloat(addToCartButton.dataset.price);
            }
            else {
                price = parseFloat(price);
            }
            const quantity = qty > 0 ? qty : 1;
            // Get the single price of the current product
            const total = price * quantity;
            totalText.innerHTML = formatPrice(total, '${{ amount }}');
            const stickyTotalText = document.querySelector('.sticky-bar__button .button [data-product-add-to-cart-total]');
            const stickyMobileTotalText = document.querySelector('.product-add__floating.button [data-product-add-to-cart-total]');
            if (!!stickyTotalText)
                stickyTotalText.innerHTML = formatPrice(total, '${{ amount }}');
            if (!!stickyMobileTotalText)
                stickyMobileTotalText.innerHTML = formatPrice(total, '${{ amount }}');
            addToCartButton.setAttribute('data-price', `${price}`);
        };
        // Update the item reference in the hidden input, if it exists.
        const updateItemRefInput = (itemRef) => {
            if (!itemRefInput) {
                return;
            }
            if (itemRef === undefined) {
                itemRefInput.value = '';
                itemRefInput.disabled = true;
                return;
            }
            itemRefInput.value = itemRef;
            itemRefInput.disabled = false;
        };
        const getQuantity = () => {
            return parseInt(hiddenQuantity.value, 10);
        };
        // Event when the variant is changed (In case a product has more than one variant)
        const variantsSelect = productForm.querySelector('[name="id"]');
        if (variantsSelect) {
            variantsSelect.addEventListener('change', (event) => {
                const selectElement = event.target;
                const { price, itemRef } = selectElement.options[selectElement.selectedIndex].dataset;
                if (complimentaryProductVariantCheckboxes.length > 0) {
                    complimentaryProductVariantCheckboxes.forEach((checkbox) => {
                        checkbox.classList.remove('product__complimentary-variant--active');
                    });
                    complimentaryProductVariantCheckboxes.forEach((checkbox) => {
                        if (selectElement.value == checkbox.dataset.variant) {
                            checkbox.classList.add('product__complimentary-variant--active');
                        }
                    });
                }
                updateCartButtonPrice(getQuantity(), price);
                updateItemRefInput(itemRef);
            });
        }
        // Reset the form after item is added or after error
        const resetForm = () => {
            if (fieldQuantity) {
                fieldQuantity.enable();
            }
            addToCartButton.removeAttribute('disabled');
            floatingAddToCartButton.removeAttribute('disabled');
            addToCartButton.classList.remove('product-add--adding');
            floatingAddToCartButton.classList.remove('product-add--adding');
            addToCartButton.classList.remove('product-add--added');
            floatingAddToCartButton.classList.remove('product-add--added');
            addingToCart = false;
        };
        // Update the button total price when the quantity field is changed
        window.addEventListener('field-quantity-keyup', (event) => {
            updateCartButtonPrice(event.detail.value);
        });
        window.addEventListener('field-quantity-value-change', (event) => {
            updateCartButtonPrice(event.detail.value);
        });
        // Here is where the product gets added to the cart
        productForm.addEventListener('submit', (event) => {
            event.preventDefault();
            if (giftCardEmail) {
                let value = giftCardEmail.value;
                let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
                console.log(value, emailRegex.test(value));
                if (!emailRegex.test(value)) {
                    giftCardEmail.classList.add('error');
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }
                else {
                    giftCardEmail.classList.remove('error');
                }
            }
            if (!addingToCart) {
                addingToCart = true;
                const productID = productForm.querySelector('[name=id]');
                if (productID.value === '') {
                    let namesWithValues = {};
                    let currentName = '';
                    optionRadios.forEach((radio) => {
                        if (radio.name !== currentName) {
                            currentName = radio.name;
                            namesWithValues[currentName] = false;
                        }
                        if (radio.checked) {
                            namesWithValues[radio.name] = true;
                        }
                    });
                    Object.keys(namesWithValues).forEach((name) => {
                        if (!namesWithValues[name]) {
                            let label = productForm.querySelector(`[name="${name}"]`).closest('.product-form__input').querySelector('.form__label');
                            label.classList.add('form__label--error');
                            label.innerHTML = `Please select a ${name}`;
                            window.scrollTo({
                                top: label.getBoundingClientRect().top + window.pageYOffset - 100,
                                behavior: 'smooth',
                            });
                        }
                    });
                    addingToCart = false;
                    return;
                }
                const productQuantity = productForm.querySelector('[name=quantity]');
                const productProperties = [...productForm.querySelectorAll('[name^=properties]')];
                const urlParams = new URLSearchParams(window.location.search);
                const quizId = urlParams.get('quizId');
                const quizKey = urlParams.get('quizKey');
                if (quizId && quizKey) {
                    productProperties.push({
                        name: 'properties[_quiz_kit_id]',
                        value: quizId
                    });
                }
                // Disable quantity input field and plus and minus icons
                if (fieldQuantity) {
                    fieldQuantity.disable();
                }
                // Hide price and add to cart and show a loading animation
                addToCartButton.setAttribute('disabled', 'disabled');
                floatingAddToCartButton.setAttribute('disabled', 'disabled');
                addToCartButton.classList.remove('product-add--added');
                floatingAddToCartButton.classList.remove('product-add--added');
                addToCartButton.classList.add('product-add--adding');
                floatingAddToCartButton.classList.add('product-add--adding');
                // Build an object containing any defined properties
                const propertiesObject = productProperties.reduce((properties, productProperty) => {
                    const { name, value } = productProperty;
                    // If the value is empty, don't include it.
                    if (value === undefined || value.length === 0) {
                        return properties;
                    }
                    const propertyName = name.match(/properties\[(.*)\]/)[1];
                    return Object.assign(properties, {
                        [propertyName]: value,
                    });
                }, {});
                const itemsToAdd = [];
                if (dataJs.product.bundle) {
                    const bundleIds = dataJs.product.bundle.split(',');
                    for (const bundleId of bundleIds) {
                        itemsToAdd.push({
                            id: bundleId,
                            quantity: parseInt(productQuantity.value, 10),
                            properties: propertiesObject,
                        });
                    }
                }
                else {
                    itemsToAdd.push({
                        id: parseInt(productID.value, 10),
                        quantity: parseInt(productQuantity.value, 10),
                        properties: propertiesObject,
                    });
                }
                if (complimentaryProductCheckbox && complimentaryProductCheckbox.checked) {
                    const productID = complimentaryProductCheckbox.dataset.product;
                    itemsToAdd.push({
                        id: parseInt(complimentaryProductCheckbox.value),
                        quantity: parseInt(productQuantity.value, 10),
                        properties: {
                            _complimentary: productID
                        }
                    });
                }
                if (complimentaryProductVariantCheckboxes.length > 0) {
                    complimentaryProductVariantCheckboxes.forEach((checkbox) => {
                        let checkboxInput = checkbox.querySelector('input');
                        if (checkbox.classList.contains('product__complimentary-variant--active') && checkboxInput.checked) {
                            itemsToAdd.push({
                                id: parseInt(checkboxInput.value),
                                quantity: parseInt(productQuantity.value, 10),
                                properties: {
                                    _complimentary: checkboxInput.dataset.product
                                }
                            });
                        }
                    });
                }
                // Add the product to the cart
                CartUtil.add(itemsToAdd, false)
                    .then((items) => {
                    if (Array.isArray(items)) {
                        // When added, show an added to cart message in the button
                        addToCartButton.classList.add('product-add--added');
                        floatingAddToCartButton.classList.add('product-add--added');
                        // When added, show a toast message below the header
                        const titles = items.map((item) => `${item.product_title}, ${item.variant_title ? item.variant_title : ''}`).join(', ');
                        Toast.show(`<b>${titles}</b> <span>${dataJs.product.addToCartToast}</span>`);
                        items.map((item) => {
                            fetch(`https://api.quizkitapp.com/api/v1/quizzes/${quizKey}/add-to-cart`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    price: item.price,
                                    variantId: item.id,
                                    source: 'quiz_result'
                                }),
                            });
                        });
                        // After 2 seconds show the default text in the button, reset quantity to 1 and enable input field and plus button
                        setTimeout(() => {
                            resetForm();
                        }, 2000);
                    }
                    else {
                        Toast.show(items === null || items === void 0 ? void 0 : items.description, 'error');
                        resetForm();
                    }
                })
                    .catch((error) => {
                    console.error(error);
                    Toast.show(dataJs.product.addToCartFailed, 'error');
                    resetForm();
                });
            }
        });
    });
}
let collapsibleTabs = document.querySelectorAll('.product__collapsible');
if (collapsibleTabs) {
    collapsibleTabs.forEach((collapsibleTab) => {
        collapsibleTab.style.setProperty('--tab-height', `${collapsibleTab.querySelector('.product__collapsible-tab').scrollHeight}px`);
        collapsibleTab.addEventListener('click', () => {
            collapsibleTab.classList.toggle('product__collapsible--active');
        });
    });
}
let productDescriptionRemaining = document.querySelector('.product__description-more');
if (productDescriptionRemaining) {
    productDescriptionRemaining.addEventListener('click', () => {
        let productDescription = document.querySelector('.product__description-remaining');
        productDescription.classList.toggle('product__description-remaining--active');
    });
}
let ingredientsMore = document.querySelectorAll('.product__ingredients-more');
let ingredientsPopup = document.querySelector('.product__ingredients-popup');
let ingredientsClose = document.querySelector('.product__ingredients-popup__close');
if (ingredientsMore) {
    ingredientsMore.forEach((ingredientMore) => {
        ingredientMore.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            ingredientsPopup.classList.toggle('product__ingredients-popup--visible');
        });
    });
    ingredientsClose.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        ingredientsPopup.classList.remove('product__ingredients-popup--visible');
    });
    ingredientsPopup.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let el = e.target;
        if (el.closest('.product__ingredients-popup__inner'))
            return;
        ingredientsPopup.classList.remove('product__ingredients-popup--visible');
    });
}
let header = document.querySelector('.header');
let notification = document.querySelector('.notification-bar');
let offsetHeight = header.offsetHeight + notification.offsetHeight;
const addToCartButton = document.querySelector('[data-product-add-to-cart]');
const outOfStockContainer = document.querySelector('.product-oos:not(.product-oos__floating)');
const footer = document.querySelector('.footer');
document.addEventListener('scroll', () => {
    let addToCartButtonLocation = addToCartButton.getBoundingClientRect();
    let outOfStockContainerLocation = outOfStockContainer.getBoundingClientRect();
    let footerLocation = footer.getBoundingClientRect();
    console.log('Out of Stock', !outOfStockContainer.classList.contains('product-oos__hidden'));
    if (!outOfStockContainer.classList.contains('product-oos__hidden')) {
        if (outOfStockContainerLocation.top < offsetHeight && footerLocation.top > window.innerHeight) {
            floatingOutofStockContainer.classList.add('product-add__floating--sticky');
        }
        else {
            floatingOutofStockContainer.classList.remove('product-add__floating--sticky');
        }
    }
    else {
        if (addToCartButtonLocation.top < offsetHeight && footerLocation.top > window.innerHeight) {
            floatingAddToCartButton.classList.add('product-add__floating--sticky');
        }
        else {
            floatingAddToCartButton.classList.remove('product-add__floating--sticky');
        }
    }
});
const variantSelect = document.querySelector('.product__content [data-product-form] [name="id"]');
const productButton = document.querySelector('.sticky-bar__atc');
const outOfStockButton = document.querySelector('.product-oos');
variantSelect.addEventListener('change', () => {
    if (!outOfStockButton.classList.contains('product-oos__hidden')) {
        floatingOutofStockContainer.classList.remove('product-oos__hidden');
        floatingAddToCartButton.classList.add('product-add__floating--hidden');
    }
    else if (productButton) {
        floatingOutofStockContainer.classList.add('product-oos__hidden');
        floatingAddToCartButton.classList.remove('product-add__floating--hidden');
    }
});
floatingAddToCartButton.addEventListener('click', () => {
    addToCartButton.click();
});
